import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const StyledContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: 1,
  width: '100%',
  marginTop: '10px',
  padding: '0 16px',
});

export const TOS = styled(Box)({
  background: '#222124',
  borderRadius: '5px',
  padding: '1px 5px 9px 0',
});

export const TermsWrapper = styled(Box)({
  margin: '0 auto',
  marginTop: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '25px !important',
});

export const IconButtonStyled = styled(Button)({
  borderRadius: '0',
  background: 'transparent !important',
  '&:hover': {
    background: 'transparent !important',
  },
  minWidth: 'auto',
});

export const TermsText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '11px',
  color: theme.palette.common.white,
  '@media (max-width: 380px)': {
    width: '220px',
    textAlign: 'center',
  },
}));

export const TermsLink = styled('a')(({ theme }) => ({
  color: theme.palette.common.white,
  textDecoration: 'underline',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const TOSWrapper = styled(Box)({
  margin: '0 auto',
  width: '282px',
  display: 'flex',
  alignItems: 'center',
});

export const Btn = styled(Button)({
  width: '100%',
  height: '52px',
  fontSize: 'clamp(16px, 4.4vw, 24px)',
  fontWeight: 600,
  borderRadius: '8px',
  '&:active': {
    transform: 'scale(0.99)',
  },
});

export const RecordButton = styled(Btn)(({ theme }) => ({
  background: theme.palette.primary.contrastText,
  color: theme.palette.primary.main,
  border: '1px solid #D0D5DD',

  '&:hover': {
    background: theme.palette.primary.contrastText,
  },
  '&:disabled': {
    color: '#DFDFDF',
    border: '1px solid #D0D5DD',
  },
}));

export const UploadButton = styled(Btn)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  marginTop: '12px',

  '&:hover': {
    background: theme.palette.primary.main,
  },
  '&:disabled': {
    background: '#DFDFDF',
  },
}));

export const UploadButtonText = styled(Typography)({
  color: 'white',
  fontWeight: 600,
  boxShadow: '0px 4px 7px -2px rgba(44, 44, 44, 0.15)',
});
